import Component from '../inherited/Component'

export default class MaxLength extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._input = this._elem.querySelector('[data-max-length-input]')
    this._notice = this._elem.querySelector('[data-max-length-notice]')
  }

  mount () {
    this._input.addEventListener('input', e => {
      this._doCount()
    })
    this._doCount()
  }

  _doCount () {
    let max = this._input.maxLength
    let remaining = max - this._input.value.length
    this._notice.innerHTML = `${remaining} ${remaining === 1 ? 'character' : 'characters'} remaining`
  }
}